import styled, {css} from 'styled-components';

const StyledFieldLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: inherit;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 6px;
`;

export const StyledFieldLabelAsterisk = styled.span`
  ${({theme}) => css`
    color: ${theme.palette.error.main};
  `}
`;

export default StyledFieldLabel;
